import * as yup from 'yup'

export const weblinkSchema = yup.object().shape({
  link: yup.string().url().nullable(),
  title: yup.string().max(255).nullable(),
  is_public: yup.boolean().nullable(),
  tags: yup.array().of(yup.string().max(255)).nullable(),
  shared_with: yup.array().of(yup.number()).nullable(),
})
